import { isNotEmpty, isNumber } from "../utils/langUtils";

export function isRetina() {
  return window.devicePixelRatio > 1;
}

export function extractBestPicture(pictures: $TSFixMe) {
  if (isNotEmpty(pictures)) {
    pictures.sort((a: $TSFixMe, b: $TSFixMe) => b.width - a.width);
    const bestSize = isRetina() ? 1000 : 500;
    let bestPicture: $TSFixMe;

    pictures.forEach((picture: $TSFixMe) => {
      if (!bestPicture || picture.width >= bestSize) {
        bestPicture = picture;
      }
    });
    return bestPicture;
  }
  return null;
}

export function extractBestPictureUrl(pictures: $TSFixMe) {
  const bestPicture = extractBestPicture(pictures);
  return bestPicture ? bestPicture.download_href : null;
}

export function extractPicture(picture: $TSFixMe) {
  const p = {
    id: picture.id,
    url: picture.download_href,
    width: picture.width,
    height: picture.height,
  };
  if (isNotEmpty(picture.type)) {
    (p as $TSFixMe).type = picture.type;
  }
  if (isNumber(picture.file_size)) {
    (p as $TSFixMe).size = picture.file_size;
  }
  return p;
}

export function extractPictures(pictures: $TSFixMe) {
  return pictures?.pictures?.map((p: $TSFixMe) => extractPicture(p));
}

export function extractThumbnailPicture(pictures: $TSFixMe) {
  if (isNotEmpty(pictures)) {
    pictures.sort((a: $TSFixMe, b: $TSFixMe) => b.width - a.width);
    const bestSize = isRetina() ? 100 : 50;
    let bestPicture: $TSFixMe;
    pictures.forEach((picture: $TSFixMe) => {
      if (!bestPicture || picture.width >= bestSize) {
        bestPicture = picture;
      }
    });

    return bestPicture;
  }
  return null;
}

export function extractThumbnailPictureUrl(pictures: $TSFixMe) {
  let pictureUrl = null;
  const bestPicture = extractThumbnailPicture(pictures);
  if (bestPicture) {
    pictureUrl = bestPicture.download_href
      ? bestPicture.download_href
      : bestPicture.url;
  }
  return pictureUrl;
}
